// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "e99863e0" + "." + "164f59fe5e3807c3" + ".js";
};